module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med sørsamisk_sentrert logo_neg(hvit).e83ff12d.pdf";